define((require) => {
    "use strict";

    const Action                                = require("shared/ui/experience/action/Action");
    const SalesforceCommerceQuickViewService    = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewService");
    const ViewerEvents                          = require("shared/services/ViewerEvents");
    const {isBlank}                             = require("shared/util/StringUtils");
    const Window                                = require("shared/services/Window");

    /**
     * Action that launches a SalesforceCommerce QuickView JavaScript function on the containing page.
     *
     * @class SalesforceCommerceQuickViewAction
     * @constructor
     */
    return Action.extend("SalesforceCommerceQuickViewAction", {

        defaults: {
            productID: ""
        },

        _clientSpace: true, // all SalesforceCommerce QuickViews run in client space always

        /**
         * @type {jQuery}
         * The root element of the SalesforceCommerce Quickview if and only if we can hook into it.
         */
        _root: null,

        _activateable() {
            if (isBlank(this.get("productID"))) {
                return "Missing product id";
            } else if (!Window.sandbox(["app.quickView.show", "__zmags.demandware.quickview.show"])) {
                return "No SalesforceCommerce Quickview found";
            }
            return null; // no error
        },

        _activate(experienceViewModel) {
            const name = experienceViewModel.get("experience").get("name");
            const currentScene = experienceViewModel.get("currentScene");
            const productId = this.get("productID");

            // Will be dependent on the different type of QuickView used... :/
            this._root = SalesforceCommerceQuickViewService.openSalesforceCommerceQuickView(productId, name, currentScene);

            const silent = {silent: true};
            const eventArgs = {type: "demandware", context: "quickview", productId};

            if (this._root) {
                this.set({
                    // Trigger a Lightbox open for consistency, just before the desired PRODUCT_VIEW event. This will
                    // also ensure that DnD behaves nicely, i.e. will close any dangling opened product windows on
                    // reload/update of the DnD page, just like our internal Lightbox...
                    event:       [ViewerEvents.LIGHTBOX_OPEN, ViewerEvents.PRODUCT_VIEW],
                    pendingEvent: ViewerEvents.LIGHTBOX_CLOSE,
                    stalled:      true,
                    paused:       false
                }, silent);

                // Listen for "dialogclose" event from the quickview so we can raise the pending event
                // to signal completion...
                this._root.one("dialogclose", this._trigger.bind(this, "pendingEvent", experienceViewModel, eventArgs));

            // Cannot be pending, but still trigger a PRODUCT_VIEW event!...
            } else {
                this.set({
                    event:        ViewerEvents.PRODUCT_VIEW,
                    pendingEvent: null,
                    stalled:      null,
                    paused:       null
                }, silent);
            }

            // Final event argument...
            return eventArgs;
        },

        close() {
            if (this._root) {
                // Use jQuery to trigger a "close", which will trigger a "dialogclose", which we listen for above - the
                // circle is complete!... :)
                this._root.trigger("close");
                this._root = null;
            }
        }

    }, {
        /** @see {WidgetTypes.SALESFORCE_COMMERCE} */
        TYPE: "demandware"
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewAction.js